import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import { push } from "react-router-redux";
import { Translate } from "react-localize-redux";


import { createUser, loadPermissions } from "../../reducer/actions";
import { getPermissions } from "../../reducer";

class UserCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            warehouses: [],
            permissions: [],
            password: ''
        }
    }

    handleSubmit() {
        this.props.createUser(this.state);
    }

    componentWillMount() {
        this.props.loadPermissions();
    }

    getPermissionOptions() {
        return this.props.permissions.map((permission) => {
            return {
                key: permission.name,
                text: permission.displayName,
                value: permission.id
            };
        });
    }


    render() {
        return (
            <div>
                <Segment style={{padding: '8em 0em'}} vertical>
                    <Grid container stackable verticalAlign='middle' centered>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <Header as='h2' color='teal' textAlign='center'>
                                    <Translate id="admin.user.create.header" />
                                </Header>
                                <Form size='large' onSubmit={() => {
                                    this.handleSubmit()
                                }}>
                                    <Segment stacked>
                                        <Translate>
                                            {
                                                ({translate}) =>
                                                    <div>
                                                        <Form.Input
                                                            label={translate("general.email")}
                                                            fluid
                                                            icon='mail outline'
                                                            iconPosition='left'
                                                            placeholder={translate("general.email")}
                                                            type={'email'}
                                                            value={this.state.email}
                                                            onChange={(e) => {
                                                                this.setState({email: e.target.value})
                                                            }}
                                                        />
                                                        <Form.Input
                                                            label={translate("general.name")}
                                                            fluid
                                                            icon='user'
                                                            iconPosition='left'
                                                            placeholder={translate("general.name")}
                                                            type={'text'}
                                                            value={this.state.name}
                                                            onChange={(e) => {
                                                                this.setState({name: e.target.value})
                                                            }}
                                                        />
                                                        <Form.Input
                                                            label={translate("general.password")}
                                                            fluid
                                                            icon='lock'
                                                            iconPosition='left'
                                                            placeholder={translate("general.password")}
                                                            type={'password'}
                                                            value={this.state.password}
                                                            onChange={(e) => {
                                                                this.setState({password: e.target.value})
                                                            }}
                                                        />
                                                        <Form.Dropdown placeholder={translate("general.permissions")} fluid multiple
                                                                       selection
                                                                       label={translate("general.permissions")}
                                                                       options={this.getPermissionOptions()}
                                                                       value={this.state.permissions}
                                                                       onChange={(e, {value}) => {
                                                                           this.setState({permissions: value})
                                                                       }}/>

                                                        <Button type='submit'>{translate("general.save")}</Button>
                                                    </div>

                                            }

                                        </Translate>
                                    </Segment>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        permissions: getPermissions(state.admin)
    };
};

const mapDispatchToProps = (dispatch) => {
    return ({
        createUser: (user) => {
            return dispatch(createUser(user)).then(() => {
                dispatch(push('/admin/users'))
            })
        },
        loadPermissions: () => {
            return dispatch(loadPermissions());
        }
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(UserCreate)



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/UserCreate/index.js